import React from 'react';
import {
  Collapse, Empty, Modal,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { UserDetail } from '../../../../../../store/users';
import { dateFormat } from '../../../../../../utils';
import PaymentDetails from './PanelDetail';

const { Panel } = Collapse;

interface IModalProps {
  data?: UserDetail;
}

export default function ModalPayments({ data }: IModalProps) {
  return Modal.info({
    className: 'paymentsModal',
    title: 'View purchase history',
    icon: null,
    closable: true,
    maskClosable: true,
    closeIcon: <CloseOutlined />,
    content: (
      <div>
        {data?.payments?.length ? (
          <Collapse
            defaultActiveKey={data?.payments?.[0]?.createdAt ? [data.payments[0].createdAt] : []}
            accordion
          >
            {data?.payments?.map((el) => (
              <Panel header={dayjs(el.createdAt).format(dateFormat)} key={el.createdAt}>
                <PaymentDetails data={el} />
              </Panel>
            ))}
          </Collapse>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    ),
  });
}

ModalPayments.defaultProps = {
  data: undefined,
};
